import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-advanaced-comparison-report',
  templateUrl: './advanaced-comparison-report.component.html',
  styleUrls: ['./advanaced-comparison-report.component.scss']
})
export class AdvanacedComparisonReportComponent implements OnInit {
  selected_from_date: any = null;
  selected_to_date: any = null;
  selected_session: any = null;
  selected_sale_type: any = null;
  selected_report_option: any = null;
  session_list: any = [];
  session_product_list: any = [];
  is_leakage_included = true;
  disable_checkbox: boolean = false;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getSession().subscribe((sessions: []) => {
      console.log(sessions);
      this.session_list = sessions;
    }, (error) => {
      console.log(error);
    });
  }

  productValueChanged(event, product_value) {
    this.document_file = null;
    if (event['checked']) {
      this.session_product_list.push(product_value);
    } else {
      let index = this.session_product_list.map((element) => {
        return element;
      }).indexOf(product_value);
      this.session_product_list.splice(index, 1);
    }
  }

  saleOptionChanged(event) {
    console.log(event);
    if (event === 'card') {
      this.is_leakage_included = false;
      this.disable_checkbox = true;
    } else {
      this.is_leakage_included = true;
      this.disable_checkbox = false;
    }
  }

  checkDisabled() {
    if (this.selected_from_date == null || this.selected_to_date == null || this.selected_session == null || this.selected_sale_type == null || this.selected_report_option == null || this.session_product_list.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  getClicked() {
    let sale_type_list = [];
    if (this.selected_sale_type === 'cash') {
      sale_type_list.push('Agent');
      if (this.is_leakage_included) {
        sale_type_list.push('Leakage');
      }
    } else if (this.selected_sale_type === 'both') {
      sale_type_list = ['Agent', 'ICustomer'];
      if (this.is_leakage_included) {
        sale_type_list.push('Leakage');
      }
    } else {
      sale_type_list.push('ICustomer');
    }
    let data_dict = {
      'from_date': this.selected_from_date,
      'to_date': this.selected_to_date,
      'session_id': this.selected_session,
      'report_option': this.selected_report_option,
      'sale_type_list': sale_type_list,
      'product_list': this.session_product_list
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveAllTypeOfReport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      console.error(error);
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getDocument() {
    return 'data:application/octet-stream;base64,' + this.document_file['excel'];
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }

}
